import * as hireActions from "../actions/hireActions";
import {updateObject} from "../../utils/util";
import produce from "immer";

const initialState = {
  hireLoaded: false,
  actualSteep:1,
  steep1:{},
  steep2:{},
  steep3:{},
  steep4:{},  
  memberFormsValid: false,
  domFacturacion: null,
  domRespPagador: null,
  tarjetas: null,
  disabledButton: true,
  selectPagador: "INTEGRANTE",
  indexPagador: 0,
  isFormNotReady: true,
  isSameAddress: false,
  dateScheduler: null,
  idTimeOutScheduler: 0
};

export function hireReducer(state = initialState, action) {
  switch (action.type) {
    case hireActions.SET_DATA_STEEP:
      switch(action.data.steep)
      {
        case 1: return updateObject(state, {steep1:action.data.data, actualSteep:action.data.actualSteep});
        case 2: return updateObject(state, {steep2:action.data.data, actualSteep:action.data.actualSteep});
        case 3: return updateObject(state, {steep3:action.data.data, actualSteep:action.data.actualSteep});
        case 4: return updateObject(state, {steep4:action.data.data, actualSteep:action.data.actualSteep});
      }
    case hireActions.SET_MEMB_F_VALID:
      return Object.assign({}, state, {
        memberFormsValid: action.payload
      });
    case hireActions.CLEAR_ALL:
        return updateObject(state, {actualSteep:1, steep1:{},steep2:{},steep3:{},steep4:{}, disabledButton: true, selectPagador: "INTEGRANTE", indexPagador: 0, isFormNotReady: true, isSameAddress: false});
    case hireActions.SET_DOM_FACTURACION:
        return  updateObject(state, { ...action.hire});
    case hireActions.SET_DOM_RESP_PAGADOR:
        return  updateObject(state, { ...action.hire});
    case hireActions.SET_DATA_TARJETAS:
        return  updateObject(state, { ...action.hire});
    case hireActions.SET_DISABLED_BUTTON:
        return  updateObject(state, { ...action.hire});
    case hireActions.SET_DATA_SELECT_PAGADOR:
        return  updateObject(state, { ...action.hire});
    case hireActions.SET_DATA_INDEX_PAGADOR:
        return  updateObject(state, { ...action.hire});
    case hireActions.SET_IS_FORM_NOT_READY:
        return  updateObject(state, { ...action.hire});
    case hireActions.SET_IS_SAME_ADDRESS:
        return  updateObject(state, { ...action.hire});
    case hireActions.SET_DATE_SCHEDULER:
        return  updateObject(state, { ...action.hire});
    case hireActions.SET_ID_TIMEOUT_SCHEDULER:
        return  updateObject(state, { ...action.hire});
    default:
      return state;
  }
}